import { ArrowLeftCircleIcon, Lock } from "lucide-react";
import MainBody from "./components/MainBody/MainBody";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "./components/ui/card";
import { Button } from "./components/ui/button";

const UnauthorisedAccess = ({ expandList = false, popup=false }) => {
  const token = localStorage.getItem("ts-auth-token");
  const navigate = useNavigate();

  if (token) {
    return (
      <MainBody search={false} className="p-0" expandList={expandList}>
        <div className="flex h-full items-center justify-center p-4">
          <Card className="max-w-md w-full shadow-lg text-center">
            <CardContent className="flex flex-col items-center gap-4 py-10">
              <Lock className="h-12 w-12 text-yellow-500" />
              <h2 className="text-2xl font-semibold ">Unauthorized</h2>
              <p>You do not have permission to view this page.</p>
              {!popup && <Button variant="outline" onClick={() => navigate(-1)}>
                Go Back
              </Button>}
            </CardContent>
          </Card>
        </div>
      </MainBody>
    );
  } else {
    return (
      <div>
        <div className="flex gap-2 h-9 items-center border-b bg-webPrimary px-4 z-[10] text-secondary-foreground">
          <div className="hover:cursor-pointer text-white">
            <div
              className="flex items-center gap-1"
              onClick={() => {
                navigate(-1);
              }}
            >
              <ArrowLeftCircleIcon size={16} />
              Back
            </div>
          </div>
        </div>
        <div className="flex h-[calc(100vh-2.25rem)] items-center justify-center  p-4">
          <Card className="max-w-md w-full shadow-lg text-center">
            <CardContent className="flex flex-col items-center gap-4 py-10">
              <Lock className="h-12 w-12 text-yellow-500" />
              <h2 className="text-2xl font-semibold ">Unauthorized</h2>
              <p>You do not have permission to view this page.</p>
              <Button variant="outline" onClick={() => navigate(-1)}>
                Go Back
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }
};

export default UnauthorisedAccess;
